import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {GameAssets} from "../../../config/texture/GameAssets";
import {gsap} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Sequence} from "../../../../core/displayobject/Sequence";

export class BigWinView extends PIXI.Container {
    private _countUp: BitmapCountUp;
    private _countUpTl: gsap.core.Timeline;
    private _shockWaveExplosion: Sequence;

    constructor() {
        super();
        this.name = "BIG_WIN";

        this.init();
    }

    public show(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this._countUp.position.set(360, 600);
        this.alpha = 0;
        this.visible = true;
        tl.add(() => {
            this._countUp.text = "";
            gsap.to(this, {duration: duration, alpha: 1});
        }, 0);

        return tl;
    }

    // #335
    public onCountUpEnd(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        // #297
        this._countUpTl.totalProgress(1);

        tl.add([
            this._shockWaveExplosion.play(),
            () => {
                this._shockWaveExplosion.visible = true;
            }
        ], 0);
        tl.to(this._countUp.scale, {
            x: 1.25,
            y: 1.25,
            duration: 0.2
        }, 0);

        tl.to(this._countUp.scale, {
            x: 1,
            y: 1,
            duration: 0.1
        }, 0.2);

        return tl;
    }

    public hide(duration: number = 0.0001): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this, {duration: duration, alpha: 0});
        tl.add(() => {
            this.visible = false;
            this._countUp.visible = false;
            this._shockWaveExplosion.visible = false;
        });

        return tl;
    }

    public getLevelAnimation(countFrom: number, countTo: number, duration: number, level: number): gsap.core.Timeline {
        Logger.logDev("getLevelAnimation called details :: from : " + countFrom + " to : " + countTo + " duration : " + duration + " level : " + level);
        const tl: gsap.core.Timeline = new gsap.core.Timeline();

        tl.add(() => {
            this.addChild(this._countUp);
        });

        const delay: number = 0;

        if (level == 0) {
            tl.add(() => {
                this._countUp.visible = true;
            }, delay);
        }

        tl.to(this, {
            duration: duration - 0.1,
            onStart: () => {
                // #297
                if (this._countUpTl) {
                    this._countUpTl.clear();
                    this._countUpTl.kill();
                }
                this._countUpTl = <gsap.core.Timeline><unknown>this._countUp.getCountUpAnimation(countFrom, countTo, (duration - 0.1));
            }
        }, (delay + 0.1));

        return tl;
    }

    private init(): void {
        this._shockWaveExplosion = this.addChild(new Sequence({texturePath:"shockWaveExplosion"}));
        this._shockWaveExplosion.visible = false;
        this._shockWaveExplosion.anchor.set(0.5);
        this._shockWaveExplosion.position.set(360, 600);
        this._shockWaveExplosion.scale.set(2);
        this._shockWaveExplosion.blendMode = PIXI.BLEND_MODES.ADD;

        this._countUp = new BitmapCountUp({
            fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
            fontSize: 68,
            align: "center",
            maxWidth: 580,
            letterSpacing: 5
        });
        this._countUp.shrinkSize = true;
        this._countUp.position.set(360, 600);
        this._countUp.text = "";
        this.addChild(this._countUp);

        this.visible = false;
        this.alpha = 0;
        this._countUp.visible = false;
    }
}
